export default "__VITE_ASSET__DjUUgjam__"